export const PASSWORD_PATTERN = String
  .raw`^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[[\]\-_.*+:#!?%{}|@[;="'&$\/,]).{8,}$`

export const MAIL_PATTERN = '^[w-.+]+@([w-]+.)+[w-]{2,4}$'
